// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { AccountAddress } from './account-address';
import { Manifest } from './manifest';
import { Program } from './program';
import { ProgramUserGroup } from './program-user-group';
import { Supplier } from './supplier';

/// <code-import> Place custom imports between <code-import> tags
import { EntityPropertyAnnotation, EntityTypeAnnotation } from '../entity-type-annotations';
import { Validator } from 'breeze-client';
/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ProgramBillingConfig extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  static getEntityTypeAnnotation(): EntityTypeAnnotation {
    const propAnnotations = [
      new EntityPropertyAnnotation('invoiceEmail', {
        validators: [BaseEntity.multipleEmailValidator],
      }),
    ];

    return new EntityTypeAnnotation({
      validators: [],
      propertyAnnotations: propAnnotations,
    });
  }
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key */
  id!: string;
  /** Guid FK billingAccountAddress */
  billingAccountAddressId?: string;
  /** String(100) */
  invoiceEmail?: string;
  /** Guid FK manifest */
  manifestId?: string;
  /** String */
  portalName?: string;
  /** Guid FK program */
  programId!: string;
  /** Guid FK programUserGroup */
  programUserGroupId?: string;
  /** Binary */
  rowVersion!: any;
  /** Guid FK supplier */
  supplierId?: string;
  /** FK billingAccountAddressId */
  billingAccountAddress!: AccountAddress;
  /** FK manifestId */
  manifest!: Manifest;
  /** FK programId */
  program!: Program;
  /** FK programUserGroupId */
  programUserGroup!: ProgramUserGroup;
  /** FK supplierId */
  supplier!: Supplier;
}

